<template>
    <div class="second-row__text-input">
        <v-chip class="text-center chip input-chip"
                :style="`width: ${inputWidth[0]}px`">
            <v-text-field
                    autocomplete="off"
                    v-model.number="form.from"
                    class="text-center input-chip"
                    label="ex: 300"
                    type="number"
                    solo>
            </v-text-field>
        </v-chip>
        <span class="chip-description">and</span>
        <v-chip class="text-center chip input-chip"
                :style="`width: ${inputWidth[1]}px`">
            <v-text-field
                    v-model.number="form.to"
                    class="text-center input-chip"
                    label="ex: 300"
                    type="number"
                    solo>
            </v-text-field>
        </v-chip>
        <span class="chip-description">{{ description }}</span>
    </div>
</template>

<script>
    export default {
        name: "InputBetween",
        props: ['value', "description"],
        data: () => ({
            form: {
                from: null,
                to: null
            },
        }),
        computed: {
            inputWidth: function () {
                const widthsArr = [];
                const defaultWidth = 70;
                widthsArr[0] = this.form.from ? (this.form.from.length + 1) * 6 + 24 : defaultWidth;
                widthsArr[1] = this.form.to ? (this.form.to.length + 1) * 6 + 24 : defaultWidth;
                return widthsArr
            }
        },
        watch: {
            form: {
                handler: function (val, oldVal) {
                    this.$emit('input', val)
                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    this.form = val
                },
                deep: true
            },
        },
        mounted() {
            if (this.value) {
                this.form = this.value
            }
        },
    }
</script>

<style scoped>

</style>
